module.exports = __webpack_public_path__ + "img/meter.2ee26da0.png";